<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>
<script>
// 引入基本模板
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");

export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "270px",
    },
  },
  data() {
    return {
      chart: null,
      date: [],
      option: {
        grid: {
            left: '3%',
            right: '2%',
            top: '9%',   
            bottom: '1%', 
            containLabel: true 
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            color: "#000"
          },
          splitLine: { show: false }  // 隐藏x轴网格线
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#000"
          },
          splitLine: { show: false }  // 隐藏Y轴网格线
        },
        color: ["#409eff"],
        series: [
          {
            // data: [820, 932, 901, 934, 1290, 1330, 1320],
            data: [],
            type: "line",
            smooth: false,
            symbolSize: 10,
            label: {
              show: true,
              position: "top",
              color: "#303133",
              fontSize: 12
            },
          },
        ],
      },
    };
  },
  mounted() {
    // this.initChart();
    // let self = this;
    // setInterval(function () {
    //   self.initChart();
    // }, 60000);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart(data) {
      this.date = [];
      for (var i = 0; i < data.length; i++) {
        this.option.series[0].data[i] = data[i].Value; //yyyy-MM-dd
        //只显示月日
        if (data[i].Name && (data[i].Name.length >= 10)) {
          data[i].Name = data[i].Name.substring(5, 10);
        }
        this.date.push(data[i].Name);
      }
      this.option.xAxis.data = this.date;
      this.chart = echarts.init(this.$el, "macarons");
      this.chart.setOption(this.option);
    },
    handleResize() {
      if(this.chart) this.chart.resize();
    },
  },
};
</script>
<style lang="scss">
.chart {
  @media screen and (max-width: 480px) {
    margin-top: -30px;
  }
}
</style>